<!--For phone numbers-->
@if (step === 'phone-numbers-checkout-summary') {
  <app-checkout-phonenumber-summary [subscription]="null"
    [phoneNumbers]="phoneNumbers"
    (buy)="onBuyPhoneNumbers()"
    [hideBackBtn]="true"
  ></app-checkout-phonenumber-summary>
}

@if (step === 'phone-numbers-thank-you') {
  <app-buy-thankyou-content
    headline="thank_you_confirm_phonenumber_headline"
    content="thank_you_confirm_phonenumber_content"
    [showBackrouteButton]="false"
  ></app-buy-thankyou-content>
}

@if (step === 'upgrade-checkout-summary') {
  <app-checkout-one-summary
    (buy)="onBuyUpgrade()"
    [hideBackBtn]="true"
    [subscription]="subscription"
  ></app-checkout-one-summary>
}

@if (step === 'flatrate-checkout-summary') {
  <app-checkout-one-summary
    (buy)="onBuyFlatrate()"
    [hideBackBtn]="true"
    [subscription]="subscription"
  ></app-checkout-one-summary>
}

@if (step === 'cancel-subscription') {
  <app-subscription-cancel-customer-confirm
    [applianceId]="saleOrder.aid"
    [applianceName]="saleOrder.applianceName"
    [nextPossibleEndDate]="saleOrder.nextPossibleEndDate"
  (confirm)="onSubscriptionCancelConfirm()"></app-subscription-cancel-customer-confirm>
}

@if (step === 'upgrade-thank-you') {
  <app-buy-thankyou-content
    headline="thank_you_confirm_upgrade_one_headline"
    content="thank_you_confirm_upgrade_one_content"
    [showBackrouteButton]="false"
  ></app-buy-thankyou-content>
}

@if (step === 'flatrate-thank-you') {
  <app-buy-thankyou-content
    headline="thank_you_confirm_tariff_headline"
    content="thank_you_confirm_tariff_content"
    [showBackrouteButton]="false"
  ></app-buy-thankyou-content>
}

@if (step === 'cancel-done') {
  <app-buy-thankyou-content
    headline="confirm_cancel_customer_done_headline"
    content="confirm_cancel_customer_done_content"
    [showBackrouteButton]="false"
  ></app-buy-thankyou-content>
}

@if (step === 'subscription-cancelled' ) {
  <app-buy-thankyou-content
    headline="subscription_already_cancelled"
    content="subscription_already_cancelled_content"
    [showBackrouteButton]="false"
  ></app-buy-thankyou-content>
}

@if (step === 'availability-downgrade') {
  <app-availability-downgrade-confirm
    [applianceId]="saleOrder.aid"
    [applianceName]="saleOrder.applianceName"
    (confirm)="onAvailabilityDowngradeConfirm()">
  </app-availability-downgrade-confirm>
}

@if (step === 'cancel-phone-number') {
  <app-checkout-one-summary
    [hideBackBtn]="true"
    (buy)="onNumberCancel()"
    [subscription]="subscription">
  </app-checkout-one-summary>
}

@if (step === 'ai-tariff-change') {
  <app-checkout-one-summary
    (buy)="onBuyFlatrate()"
    [hideBackBtn]="true"
    [subscription]="subscription"
  ></app-checkout-one-summary>
}

@if (step === 'offer-not-existing' || step === 'offer-cancelled' || step === 'offer-expired') {
  <div>
    <div class="content-card-container-bg">
      <div class="content-card-container">
        <div class="content-card text-align-center">
          <div>
            <img src="assets/images/animals/wal.svg" alt="pascom welcome picture">
          </div>
          @if (step === 'offer-not-existing') {
            @if (step === 'offer-not-existing') {
              <div>
                <h1 [innerHTML]="'partner_offer_not_existing_headline' | i18next"></h1>
                <p class="gray" [innerHTML]="'partner_offer_not_existing_content' | i18next"></p>
              </div>
            }
          }
          @if (step === 'offer-cancelled') {
            @if (step === 'offer-cancelled') {
              <div>
                <h1 [innerHTML]="'partner_offer_cancelled_headline' | i18next"></h1>
                <p class="gray" [innerHTML]="'partner_offer_cancelled_content' | i18next"></p>
              </div>
            }
          }
          @if (step === 'offer-expired') {
            <div>
              <h1 [innerHTML]="'partner_offer_expired_headline' | i18next"></h1>
              <p class="gray" [innerHTML]="'partner_offer_expired_content' | i18next"></p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
